import * as React from 'react'
import { useState } from 'react'

import { Card } from '@/app/features/common/Card'
import { CalculatorIcon } from '@/app/features/icons/Calculator'
import { AbacusIcon } from '@/app/features/icons/Abacus'
import { GenerateBox } from '../../components/GenerateBox'
import { LoadingScreen } from '../../components/LoadingScreen'
import { FooterWithButtons } from '../../components/FooterWithButtons'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

type Props = {
  onGenerate: (fullEvidence: boolean) => Promise<void> | void
  onPrev?: () => void
  isLoading?: boolean
}
export const EvidenceFirstSubstep = ({
  onGenerate,
  onPrev,
  isLoading = false,
}: Props) => {
  const { tSafe } = useLocalize()
  const [isLocalLoading, setIsLocalLoading] = useState(false)

  const handleClick = async (fullEvidence: boolean) => {
    setIsLocalLoading(true)
    try {
      await onGenerate(fullEvidence)
    } finally {
      setIsLocalLoading(false)
    }
  }

  const showLoading = isLoading || isLocalLoading
  return (
    <Card
      className="tw-inline-block tw-h-full tw-max-w-full tw-overflow-x-auto tw-bg-base-100 "
      classNameContent="!tw-px-0  tw-overflow-x-auto tw-flex tw-flex-col tw-h-full"
      paddingTop={false}
    >
      {showLoading ? (
        <div className="tw-flex tw-flex-1">
          <LoadingScreen
            text={tSafe(
              'creator.evidence.calculating',
              'Przeliczanie ewidencji...',
            )}
          />
        </div>
      ) : (
        <div className="tw-relative tw-flex tw-flex-1 tw-flex-col md:tw-flex-row">
          <div className="tw-flex tw-flex-1 tw-pb-2 md:tw-pb-4 tw-pl-4 tw-pr-4 tw-pt-4 md:tw-pr-2">
            <GenerateBox
              title={tSafe(
                'creator.evidence.generateShort.title',
                'Wygeneruj skróconą ewidencję',
              )}
              subtitle={tSafe(
                'creator.evidence.generateShort.subtitle',
                'Otrzymasz skrócony układ tabeli z podstawowymi danymi.',
              )}
              icon={CalculatorIcon}
              onClick={() => handleClick(false)}
              classNameContent="tw-w-72"
            />
          </div>
          <div className="tw-flex tw-flex-1 tw-pb-4 tw-pl-4 tw-pr-4 tw-pt-2 md:tw-pt-4 md:tw-pl-2 ">
            <GenerateBox
              title={tSafe(
                'creator.evidence.generateFull.title',
                'Wygeneruj pełną ewidencję',
              )}
              subtitle={tSafe(
                'creator.evidence.generateFull.subtitle',
                'Otrzymasz kompleksowy układ tabeli z możliwością edycji.',
              )}
              icon={AbacusIcon}
              onClick={() => handleClick(true)}
              classNameContent="tw-w-[240px]"
            />
          </div>
          <span className="tw-absolute tw-bottom-0 tw-left-1/2 tw-top-0 tw-flex -tw-translate-x-1/2 tw-items-center tw-justify-center">
            <span className="tw-bg-base-100 tw-p-2 tw-text-xl">
              {tSafe('creator.evidence.or', 'albo')}
            </span>
          </span>
        </div>
      )}
      <FooterWithButtons
        onPrev={onPrev}
        isNext={false}
        className="tw-border-t tw-border-base-300"
      />
    </Card>
  )
}
